//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      mounted: false
    }
  },
  mounted () {
    this.mounted = true
    this.tl = gsap.timeline({
      onComplete: (...args) => {
        this.$emit('complete', ...args)
      }
    })

    this.tl.set(['#hand', '#bank'], { opacity: 0 })
    this.tl.from('#hand', { y: -500, opacity: 0, duration: 3, ease: 'expo.out' })
    this.tl.from('#bank', { y: 500, opacity: 0, duration: 1, ease: 'expo.out' }, '<0.2')
    // this.tl.to(['#hand', '#bank'], { opacity: 0, duration: 0.1, delay: 3 })
  },
  beforeDestroy () {
    this.tl.kill()
  }
}
